module.exports = __webpack_public_path__ + "static/media/Black Panther 2.ed979bf5.jpg";